import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshaccess, logoutUser } from '../../features/user/userSlice';
import { RootState } from '../../store/store';

const TokenManager: React.FC = () => {
  const dispatch = useDispatch();
  const { access, refresh } = useSelector((state: RootState) => state.user);

  useEffect(() => {
    const checkTokenExpiration = async () => {
      if (access) {
        const expirationTime = getTokenExpiration(access);
        if (expirationTime && expirationTime < Date.now()) {
          try {
            await dispatch(refreshaccess(refresh) as any);
          } catch (error) {
            console.error('Error refreshing token', error);
            dispatch(logoutUser());
          }
        }
      }
    };

    checkTokenExpiration();
    // Interval to check token expiration periodically
    const interval = setInterval(checkTokenExpiration, 5 * 60 * 1000); // every 5 minutes

    return () => clearInterval(interval);
  }, [access, refresh, dispatch]);

  const getTokenExpiration = (token: string | null): number | null => {
    if (!token) return null;
    const [, payload] = token.split('.');
    const decodedPayload = JSON.parse(atob(payload));
    return decodedPayload.exp * 1000;
  };

  return null; // This component doesn't need to render anything
};

export default TokenManager;
